import { createNewRNGConfig } from '.'

// future code historians will wonder about this for ages

const tmpRng = createNewRNGConfig()

export default tmpRng
